import { render, staticRenderFns } from "./JobView.vue?vue&type=template&id=10532565&scoped=true&"
import script from "./JobView.vue?vue&type=script&lang=ts&"
export * from "./JobView.vue?vue&type=script&lang=ts&"
import style0 from "./JobView.vue?vue&type=style&index=0&id=10532565&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10532565",
  null
  
)

export default component.exports